<template>
  <div class="login">
    <h1> New account </h1>
    <p>Let's create a new account!</p>
    <label>
      <b-form-input class="loginInput" type="text" v-model="email" placeholder="Email" autofocus />
    </label>
    <label>
      <b-form-input class="loginInput" type="password" v-model="password" placeholder="Password"/>
    </label>

    <b-row>
      <b-col>     <!--OM inloggning inte är godkänd, sätt denna till true-->
        <b-alert class="mt-5" show variant="danger" v-show="false"> Felaktig inloggning </b-alert>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-button @click="signUp" class="belizeBlue">Sign Up</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div class="message">or go back to <router-link to="/">login</router-link>
        </div>
        <hr class="my-4">
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import login from '../css/login.scss'; //eget stylesheet  för login och sign-up
  import firebase from 'firebase';
  export default {
    name: 'signUp',
    components: { },
    data() {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      signUp: function() {
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
                (user) => {
                  this.$router.replace('home')
                },
                (err) => {
                  alert('Oops. ' + err.message)
                }
        );
      }
    }
  }
</script>

<style scoped lang="scss">
  .login {
        a {
          color: dodgerblue;
        }
      }
</style>



// WEBPACK FOOTER //
// src/views/SignUp.vue